<template>
  <div class="flex">
    <svg-icon type="mdi" :path="path"></svg-icon>
  </div>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiTrashCanOutline } from "@mdi/js"

export default {
  name: "TrashCanOutlineIcon",
  components: {
    SvgIcon
  },
  data() {
    return {
      path: mdiTrashCanOutline,
    }
  }
}
</script>
